import React, { useEffect } from 'react';

import VisualFlow from 'app/modules/admin/visualFlow/VisualFlow';
import { useHistory } from 'react-router-dom';
import useStore, { IStore } from 'app/store';

const VisFlow: React.FC = () => {
    const setSearchOrigin = useStore((state: IStore) => state.setSearchOrigin);
    const history = useHistory();
    useEffect(() => {
        setSearchOrigin(history?.location?.pathname);
    }, []);
    return (
        <>
            <VisualFlow />
        </>
    );
};

export default VisFlow;
